import React from 'react';

function BaseButton({ text, icon, handleOnClick, className = '', type = "button", iconClassName = '' }) {
    return (
        <button
            type={type}
            className={`baseButton baseButton--hasIcon baseButton--mobile ${className}`}
            onClick={handleOnClick}
        >
            {icon && (
                <img
                    src={icon}
                    className={`baseButton__icon baseButton--black ${iconClassName}`}
                    alt=""
                />
            )}
            <span className="baseButton__text">{text}</span>
        </button>
    );
}

export default BaseButton;

